import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import { BlogEntityEnum, BlogEntityTitleEnum, BlogPageEnum } from 'modules/automation-rules/enums/automation-rule-enum';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerBlogEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { AutomationRuleBlogEntityDataInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { getBlogEntityId, getBlogEntityValue, getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBlogPostNextjsUrl } from 'shared/utils/get-blog-post-nextjs-url';
import { OpenInNewIcon } from '@systemeio/ui/icons';
interface TriggerBlogItemProps extends EditTriggerItemInterface<TriggerBlogEditInterface> {}
const TriggerBlogItem = t0 => {
  const $ = _c(42);
  const {
    triggers,
    trigger,
    idx,
    onDelete,
    setRules,
    errors,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t(BlogEntityTitleEnum.blog_page);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      id: BlogEntityEnum.blog_page,
      caption: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(BlogEntityTitleEnum.blog_post_body);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      id: BlogEntityEnum.blog_post_body,
      caption: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(BlogEntityTitleEnum.blog_post_layout);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      id: BlogEntityEnum.blog_post_layout,
      caption: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t(BlogEntityTitleEnum.blog_layout);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = {
      id: BlogEntityEnum.blog_layout,
      caption: t7
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = [t2, t4, t6, t8];
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const blogEntityData = t9;
  let t10;
  if ($[21] !== idx || $[22] !== onDelete) {
    t10 = () => onDelete(idx);
    $[21] = idx;
    $[22] = onDelete;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== blogEntityData || $[25] !== errors.automationTriggers || $[26] !== idx || $[27] !== isStatic || $[28] !== setRules || $[29] !== t || $[30] !== trigger.blog || $[31] !== trigger.id || $[32] !== trigger.page.blogPage?.name || $[33] !== trigger.page.blogPost?.name || $[34] !== trigger.page.id || $[35] !== trigger.page.type || $[36] !== triggers) {
    t11 = t12 => {
      const {
        renderTriggerLabel,
        data,
        onOpen,
        onClear
      } = t12;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.blog_page_form_subscribed)} label={renderTriggerLabel({
          label: t("dashboard.blog.title"),
          additionalLabel: trigger.blog.id ? <LinkWithoutPrefetch href={getBlogPostNextjsUrl(trigger.blog.id)} className="group self-center outline-hidden" target="_blank"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_blog")} value={trigger.blog.id} staticData={getDataFromObj(trigger.blog)} data={data.blogData} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  blog: {
                    id: data_0
                  },
                  page: {
                    type: undefined,
                    id: undefined
                  }
                };
              } else {
                return el;
              }
            })
          }));
          onClear(AutomationRuleTriggersDataEnum.blog_page_form_subscribed_page);
          onClear(AutomationRuleTriggersDataEnum.blog_page_form_subscribed_post);
        }} error={errors.automationTriggers[trigger.id]?.blog?.join("")} />{trigger.blog.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.blog_page_form_subscribed)} label={t("dashboard.automation_rule.edit.blog_entity")} placeholder={t("dashboard.automation_rule.choose_blog_entity")} staticData={[{
          id: getBlogEntityValue(trigger.page.type),
          caption: t(BlogEntityTitleEnum[trigger.page.type as keyof typeof BlogEntityTitleEnum])
        }]} required={true} value={getBlogEntityValue(trigger.page.type)} data={data.blogData ? blogEntityData : undefined} onChange={newData => setRules(prev_0 => ({
          ...prev_0,
          triggers: triggers.map((el_0, i_0) => {
            if (idx === i_0) {
              if (data.blogEntityData && trigger.blog.id) {
                return {
                  ...el_0,
                  page: {
                    type: newData,
                    id: getBlogEntityId(data.blogEntityData, trigger.blog.id, newData)
                  }
                };
              } else {
                return {
                  ...el_0,
                  page: {
                    type: newData,
                    id: undefined
                  }
                };
              }
            } else {
              return el_0;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.blog_entity?.join("")} />}{(trigger.page.type === BlogEntityEnum.blog_page || trigger.page.type === BlogPageEnum.blog_home || trigger.page.type === BlogPageEnum.blog_static || trigger.page.type === BlogPageEnum.blog_post_listing || trigger.page.type === BlogPageEnum.blog_search) && trigger.blog.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.blog_page_form_subscribed_page)} label={t("dashboard.automation_rule.edit.choose_page")} placeholder={t("dashboard.automation_rule.choose_blog_page")} required={true} value={trigger.page.id} staticData={getDataFromObj({
          id: trigger.page.id,
          name: trigger.page.blogPage?.name
        })} data={data.blogPagesData} onChange={data_1 => setRules(prev_1 => ({
          ...prev_1,
          triggers: triggers.map((el_1, i_1) => {
            if (idx === i_1) {
              return {
                ...el_1,
                page: {
                  type: trigger.page.type,
                  id: data_1
                }
              };
            } else {
              return el_1;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.page?.join("")} />}{trigger.page.type === BlogEntityEnum.blog_post_body && trigger.blog.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.blog_page_form_subscribed_post)} label={t("dashboard.automation_rule.edit.choose_page")} placeholder={t("dashboard.automation_rule.choose_blog_post")} required={true} value={trigger.page.id} staticData={getDataFromObj({
          id: trigger.page.id,
          name: trigger.page.blogPost?.name
        })} data={data.blogPostsData} onChange={data_2 => setRules(prev_2 => ({
          ...prev_2,
          triggers: triggers.map((el_2, i_2) => {
            if (idx === i_2) {
              return {
                ...el_2,
                page: {
                  type: trigger.page.type,
                  id: data_2
                }
              };
            } else {
              return el_2;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.page?.join("")} />}</>;
    };
    $[24] = blogEntityData;
    $[25] = errors.automationTriggers;
    $[26] = idx;
    $[27] = isStatic;
    $[28] = setRules;
    $[29] = t;
    $[30] = trigger.blog;
    $[31] = trigger.id;
    $[32] = trigger.page.blogPage?.name;
    $[33] = trigger.page.blogPost?.name;
    $[34] = trigger.page.id;
    $[35] = trigger.page.type;
    $[36] = triggers;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== trigger) {
    t12 = <EditTriggerWrapper trigger={trigger} onDelete={t10}>{t11}</EditTriggerWrapper>;
    $[38] = t10;
    $[39] = t11;
    $[40] = trigger;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
};
export default TriggerBlogItem;